// Copyright 2022, Imprivata, Inc.  All rights reserved.

import i18n, { type InitOptions } from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalResourcesBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './translations/en.json';
import esMXTranslations from './translations/es-MX.json';

// Reduced to only contexts referenced in code/tests (LOGIN, DASHBOARD, REPORTS, LOCATIONS)
export enum ContextNames {
  DASHBOARD = 'dashboard',
  LOGIN = 'login',
  REPORTS = 'reports',
  LOCATIONS = 'locations',
}

export const defaultNS = 'translation';

export const ns = [defaultNS];

export const resources = {
  en: { [defaultNS]: enTranslations },
  es: { [defaultNS]: esMXTranslations },
  'es-MX': { [defaultNS]: esMXTranslations },
} as const;

const i18nInstance = i18n.createInstance({
  debug: false,
  defaultNS,
  ns,
  fallbackLng: ['en'],
  supportedLngs: ['en', 'es', 'es-MX'],
  load: 'languageOnly',
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  resources,
  backend: {
    backends: [LocalResourcesBackend(resources)],
  },
  detection: {
    order: ['navigator', 'localStorage', 'htmlTag'],
    caches: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
  },
  preload: ['en', 'es', 'es-MX'],
  react: { useSuspense: true },
} as InitOptions);

void i18nInstance.use(ChainedBackend).use(LanguageDetector).init();

export * from './localeProvider';

export { i18nInstance as i18n };
export default i18nInstance;
